"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tyres = function Tyres() {
  return _react2.default.createElement(
    "g",
    { id: "tyres" },
    _react2.default.createElement("path", {
      d: "M250,0 C112,0 0,112 0,250 C0,388 112,500 250,500 C388,500 500,388 500,250 C500,112 388,0 250,0 L250,0 Z M250,414.8 C158.8,414.8 85.2,341.2 85.2,250 C85.2,158.8 158.8,85.2 250,85.2 C341.2,85.2 414.8,158.8 414.8,250 C414.8,341.2 341.2,414.8 250,414.8 L250,414.8 Z M250,202.2 C223.7,202.2 202.2,223.7 202.2,250 C202.2,276.3 223.7,297.8 250,297.8 C276.3,297.8 297.8,276.3 297.8,250 C297.8,223.7 276.3,202.2 250,202.2 L250,202.2 Z",
      id: "Fill-87"
    })
  );
};

exports.default = Tyres;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Tyres.js
// module id = 3005
// module chunks = 4